// extracted by mini-css-extract-plugin
export default {"imageWrapper":"cP-z","hovered":"dP-z","hoverImage":"eP-z","mainImage":"fP-z","imageNoBackground":"gP-z","fullSizeImage":"hP-z"};